import PageHelmet from './PageHelmet';

export default PageHelmet;
